<template>
  <div class="trainingPage" id="trainingPage" ref="trainingPage">
    <div class="content-stream">

      <!-- 顶部奖励条 -->
      <section class="rewards-banner" aria-label="Daily rewards">
        <div class="rewards-left">
          <div class="rewards-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" class="icon-bolt">
              <path d="M13 2L3 14h8l-2 8 10-12h-8l2-8z"/>
            </svg>
          </div>
          <div class="rewards-label">
            <span class="rewards-title">{{ $t('lang.training.rewardsTitle') }}</span>
            <span class="rewards-pro">{{ $t('lang.training.pro') }}</span>
          </div>
        </div>
        <button class="btn btn-solid rewards-claim" type="button" @click="onClaimAll">{{ $t('lang.training.claimAll') }}</button>
      </section>

      <!-- My Training -->
      <div class="section-header">
        <h2 class="section-title">{{ $t('lang.training.myTraining') }}</h2>
        <span class="counter-badge">{{ $t('lang.training.activeCount', {count: activeCount}) }}</span>
      </div>

      <div class="card card-empty">
        <span class="empty-dot" aria-hidden="true"></span>
        <p class="empty-text">{{ $t('lang.training.emptyText') }}</p>
      </div>

      <div class="card card-free">
        <div class="free-info">
          <div class="free-title-row">
            <svg viewBox="0 0 24 24" class="icon-shield" fill="none" stroke="currentColor" stroke-width="2"
                 aria-hidden="true">
              <path
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="free-title">{{ $t('lang.training.freeExperience') }}</span>
          </div>
          <div class="free-pill">
            <span>{{ $t('lang.training.days', {days: freeExperience.days}) }}</span>
            <span class="dot-sep">·</span>
            <span>{{ $t('lang.training.deposit', {amount: separateThousandInteger(freeExperience.deposit)}) }}</span>
          </div>
        </div>
        <button class="btn btn-outline free-start" type="button" @click="onStartFree">{{ $t('lang.training.startFree') }}</button>
      </div>

      <!-- Available Programs -->
      <div class="section-header section-header--mt">
        <h2 class="section-title">{{ $t('lang.training.availablePrograms') }}</h2>
      </div>

      <div class="card card-program" v-for="p in programs" :key="p.key">
        <div class="program-top">
          <span class="popular-badge" v-if="p.popular">{{ $t('lang.training.popular') }}</span>
          <h3 class="program-title">{{ $t(p.titleKey) }}</h3>
          <div class="program-tags">
            <span class="tag-deposit">{{ $t('lang.training.deposit', {amount: separateThousandInteger(p.deposit)}) }}</span>
            <span class="tag-discount" v-if="p.discountKey">{{ $t(p.discountKey) }}</span>
          </div>
        </div>
        <div class="program-bottom">
          <div class="program-earn">
            <span class="earn-value">{{ $t('lang.training.earn', {amount: separateThousandInteger(p.earn)}) }}</span>
            <span class="earn-time">{{ $t('lang.training.timeMins', {mins: p.mins}) }}</span>
          </div>
          <button class="btn btn-solid program-start" type="button" @click="onStart(p)">
            <span>{{ $t('lang.training.start') }}</span>
            <svg viewBox="0 0 24 24" class="icon-arrow" fill="none" stroke="currentColor" stroke-width="2"
                 aria-hidden="true">
              <path d="M14 5l7 7m0 0l-7 7m7-7H3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {separateThousandInteger} from '@/utils'

export default {
  name: 'Training',
  components: {},
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      activeCount: 0,
      freeExperience: {days: 0, deposit: 0},
      // 静态占位数据：文案走 i18n（titleKey/discountKey），数值为基准屏 T6 (ebff0275) 占位。
      // 后端 Training 接口尚未提供，service/service2 不在本次改动范围；接口就绪后改为 mounted 请求并填充同名结构。
      programs: [
        {
          key: '7d',
          popular: true,
          titleKey: 'lang.training.programTitles.p7d',
          deposit: 20000,
          discountKey: 'lang.training.discount.firstTime',
          earn: 1400,
          mins: 15
        },
        {
          key: '14d',
          popular: true,
          titleKey: 'lang.training.programTitles.p14d',
          deposit: 10000,
          discountKey: null,
          earn: 123200,
          mins: 15
        },
        {
          key: '3d',
          popular: false,
          titleKey: 'lang.training.programTitles.p3d',
          deposit: 2000,
          discountKey: null,
          earn: 3200,
          mins: 15
        }
      ]
    }
  },
  watch: {},
  async mounted () {
    // TODO: 接入后端 Training 数据（可领取奖励 / 进行中训练 / 可选 program 列表）
  },
  beforeDestroy () {
  },
  methods: {
    separateThousandInteger,
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setInternationName: 'setInternationName',
      setInternation: 'setInternation'
    }),
    onClaimAll () {
      // TODO: 领取每日免费奖励接口
    },
    onStartFree () {
      // TODO: 开始免费体验
    },
    onStart (program) {
      // 进入 Program Detail（该页由本流程后续落地，路由就绪后放开）
      // this.$router.push({path: '/ProgramDetail', query: {key: program.key}})
    }
  }
}
</script>

<style lang='less' scoped>
.trainingPage {
  height: 100dvh;
  overflow: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  background: var(--stitch-page-bg);
  padding-top: calc(60vw / 3.6); /* App 壳层 TopBar 占位（同 TopBar height）*/
}

.content-stream {
  display: flex;
  flex-direction: column;
  gap: calc(14vw / 3.6);
  padding: calc(4vw / 3.6) calc(16vw / 3.6) calc(88vw / 3.6);
}

/* ---- 通用按钮 ---- */
.btn {
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: calc(12vw / 3.6);
  height: calc(34vw / 3.6);
  border-radius: var(--stitch-radius-lg);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: calc(6vw / 3.6);
  flex-shrink: 0;
  transition: background-color .12s ease, opacity .12s ease;
  -webkit-tap-highlight-color: transparent;
}

.btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}

.btn-solid {
  background: var(--stitch-brand);
  color: var(--stitch-surface);
  padding: 0 calc(14vw / 3.6);
  box-shadow: 0 calc(1vw / 3.6) calc(2vw / 3.6) rgba(0, 81, 223, .18);
}

.btn-solid:active {
  opacity: .9;
}

.btn-outline {
  background: var(--stitch-surface);
  color: var(--stitch-brand);
  border: calc(1vw / 3.6) solid #E2E8F0;
  padding: 0 calc(12vw / 3.6);
}

/* ---- 奖励条 ---- */
.rewards-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(8vw / 3.6);
  background: var(--stitch-rewards-bg);
  border: calc(1vw / 3.6) solid var(--stitch-rewards-border);
  border-radius: var(--stitch-radius-xl);
  padding: calc(12vw / 3.6);
  box-shadow: 0 calc(1vw / 3.6) calc(2vw / 3.6) rgba(0, 0, 0, .03);
}

.rewards-left {
  display: flex;
  align-items: center;
  gap: calc(10vw / 3.6);
  min-width: 0;
}

.rewards-icon {
  width: calc(32vw / 3.6);
  height: calc(32vw / 3.6);
  border-radius: var(--stitch-radius-lg);
  background: var(--stitch-icon-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--stitch-brand);
}

.rewards-icon .icon-bolt {
  width: calc(16vw / 3.6);
  height: calc(16vw / 3.6);
  fill: currentColor;
}

.rewards-label {
  display: flex;
  align-items: center;
  gap: calc(6vw / 3.6);
  min-width: 0;
}

.rewards-title {
  font-size: calc(13vw / 3.6);
  font-weight: 700;
  color: var(--stitch-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rewards-pro {
  font-size: calc(10vw / 3.6);
  font-weight: 700;
  color: var(--stitch-brand);
  background: var(--stitch-surface);
  padding: calc(2vw / 3.6) calc(6vw / 3.6);
  border-radius: calc(4vw / 3.6);
  line-height: 1;
  flex-shrink: 0;
}

/* ---- 区块标题 ---- */
.section-header {
  display: flex;
  align-items: center;
  gap: calc(8vw / 3.6);
  margin-top: calc(4vw / 3.6);
}

.section-header--mt {
  margin-top: calc(8vw / 3.6);
}

.section-title {
  font-size: calc(14vw / 3.6);
  font-weight: 700;
  color: var(--stitch-text-primary);
}

.counter-badge {
  font-size: calc(11vw / 3.6);
  font-weight: 600;
  color: var(--stitch-brand);
  background: var(--stitch-counter-bg);
  padding: calc(2vw / 3.6) calc(8vw / 3.6);
  border-radius: var(--stitch-radius-full);
}

/* ---- 卡片通用 ---- */
.card {
  background: var(--stitch-surface);
  border: calc(1vw / 3.6) solid var(--stitch-card-border);
  border-radius: var(--stitch-radius-xl);
  box-shadow: 0 calc(1vw / 3.6) calc(2vw / 3.6) rgba(0, 0, 0, .04);
}

/* 空状态卡 */
.card-empty {
  padding: calc(14vw / 3.6);
  display: flex;
  align-items: flex-start;
  gap: calc(10vw / 3.6);
}

.empty-dot {
  width: calc(8vw / 3.6);
  height: calc(8vw / 3.6);
  border-radius: var(--stitch-radius-full);
  background: var(--stitch-brand);
  flex-shrink: 0;
  margin-top: calc(6vw / 3.6);
}

.empty-text {
  font-size: calc(13vw / 3.6);
  color: var(--stitch-text-primary);
  font-weight: 500;
  line-height: 1.375;
}

/* 免费体验卡 */
.card-free {
  background: var(--stitch-free-bg);
  border-color: var(--stitch-free-border);
  padding: calc(14vw / 3.6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(12vw / 3.6);
}

.free-info {
  display: flex;
  flex-direction: column;
  gap: calc(6vw / 3.6);
}

.free-title-row {
  display: flex;
  align-items: center;
  gap: calc(6vw / 3.6);
  color: #334155;
}

.free-title-row .icon-shield {
  width: calc(16vw / 3.6);
  height: calc(16vw / 3.6);
}

.free-title {
  font-size: calc(14vw / 3.6);
  font-weight: 700;
  color: var(--stitch-text-primary);
}

.free-pill {
  display: inline-flex;
  align-items: center;
  font-size: calc(11vw / 3.6);
  font-weight: 500;
  color: var(--stitch-text-secondary);
  background: rgba(255, 255, 255, .6);
  padding: calc(2vw / 3.6) calc(8vw / 3.6);
  border-radius: calc(4vw / 3.6);
  border: calc(1vw / 3.6) solid rgba(219, 234, 254, .5);
  width: fit-content;
}

.free-pill .dot-sep {
  margin: 0 calc(4vw / 3.6);
}

.free-start {
}

/* Program 卡 */
.card-program {
  padding: calc(16vw / 3.6);
  display: flex;
  flex-direction: column;
  gap: calc(14vw / 3.6);
}

.program-top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: calc(6vw / 3.6);
}

.popular-badge {
  background: var(--stitch-badge-red);
  color: var(--stitch-surface);
  font-size: calc(10vw / 3.6);
  font-weight: 700;
  padding: calc(2vw / 3.6) calc(6vw / 3.6);
  border-radius: calc(4vw / 3.6);
  line-height: 1;
}

.program-title {
  font-size: calc(14vw / 3.6);
  font-weight: 700;
  color: var(--stitch-text-primary);
}

.program-tags {
  display: flex;
  align-items: center;
  gap: calc(8vw / 3.6);
  flex-wrap: wrap;
}

.tag-deposit {
  font-size: calc(12vw / 3.6);
  color: var(--stitch-text-secondary);
}

.tag-discount {
  font-size: calc(11vw / 3.6);
  font-weight: 600;
  color: var(--stitch-brand);
  background: var(--stitch-brand-light);
  padding: calc(2vw / 3.6) calc(6vw / 3.6);
  border-radius: calc(4vw / 3.6);
}

.program-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: calc(4vw / 3.6);
}

.program-earn {
  display: flex;
  flex-direction: column;
}

.earn-value {
  font-size: calc(12vw / 3.6);
  font-weight: 700;
  color: var(--stitch-brand);
}

.earn-time {
  font-size: calc(11vw / 3.6);
  color: var(--stitch-text-secondary);
}

.program-start {
  padding: 0 calc(16vw / 3.6);
}

.program-start .icon-arrow {
  width: calc(14vw / 3.6);
  height: calc(14vw / 3.6);
}
</style>



// WEBPACK FOOTER //
// src/pages/Training/index.vue